import { NumericValue, decimalOrZero } from '../math/Decimal';

const NUMBER_DECIMAL_POINTS = 2;

export const formatNumericValue = (value: NumericValue | undefined, decimalPoints: number = NUMBER_DECIMAL_POINTS):
string => {
  const decimalValue = decimalOrZero(value);
  return decimalValue.toFormat(decimalPoints, { groupSeparator: ',', decimalSeparator: '.', groupSize: 3 });
};
